/**
 * @generated SignedSource<<c6e205eba028bff3993b6359d47c4839>>
 * @relayHash 276cc0ce194a50887281eed054abed3f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0db505607c0944e5068444603d621d9ae560a39fed3fce4efe1483aed6d35fe0

import type { ConcreteRequest } from 'relay-runtime';
export type AccessStatus = "ANONYMOUS_ACCESS" | "EXTERNAL_COLLABORATOR_ACCESS" | "EXTERNAL_SHARE_ACCESS" | "LICENSED_ADMIN_ACCESS" | "LICENSED_USE_ACCESS" | "NOT_PERMITTED" | "UNLICENSED_AUTHENTICATED_ACCESS" | "%future added value";
export type ConfluenceEdition = "FREE" | "PREMIUM" | "STANDARD" | "%future added value";
export type Environment = "DEVELOPMENT" | "PRODUCTION" | "STAGING" | "%future added value";
export type SiteInformationQuery$variables = Record<PropertyKey, never>;
export type SiteInformationQuery$data = {
  readonly abTestCohorts: string | null | undefined;
  readonly confluence_tenantContext: {
    readonly editions: {
      readonly confluence: ConfluenceEdition;
    };
    readonly licenseStates: {
      readonly confluence: {
        readonly ccpEntitlementId: string | null | undefined;
      } | null | undefined;
    } | null | undefined;
    readonly monolithRegion: string | null | undefined;
    readonly timeZone: string | null | undefined;
  } | null | undefined;
  readonly currentConfluenceUser: {
    readonly isAnonymous: boolean;
  } | null | undefined;
  readonly experimentFeatures: string | null | undefined;
  readonly getAIConfig: {
    readonly isAIEarlyAccessEnabled: boolean | null | undefined;
    readonly isEnabled: boolean;
    readonly isRovoEnabled: boolean | null | undefined;
    readonly isRovoLLMEnabled: boolean | null | undefined;
  } | null | undefined;
  readonly isNewUser: boolean | null | undefined;
  readonly isSiteAdmin: boolean | null | undefined;
  readonly organization: {
    readonly orgId: string | null | undefined;
  } | null | undefined;
  readonly siteDescription: {
    readonly logoUrl: string | null | undefined;
  } | null | undefined;
  readonly siteSettings: {
    readonly companyHubName: string | null | undefined;
    readonly frontCover: {
      readonly frontCoverState: string | null | undefined;
    } | null | undefined;
    readonly homepage: {
      readonly title: string | null | undefined;
      readonly uri: string | null | undefined;
    } | null | undefined;
    readonly isHideTitleInUrl: boolean;
    readonly showApplicationTitle: boolean;
    readonly siteTitle: string;
  } | null | undefined;
  readonly tenant: {
    readonly activationId: string | null | undefined;
    readonly cloudId: string;
    readonly environment: Environment;
    readonly shard: string;
  } | null | undefined;
  readonly user: {
    readonly confluence: {
      readonly accessStatus: AccessStatus;
      readonly accountId: string | null | undefined;
      readonly locale: string;
      readonly userKey: string | null | undefined;
    } | null | undefined;
    readonly displayName: string | null | undefined;
    readonly id: string | null | undefined;
    readonly timeZone: string | null | undefined;
  } | null | undefined;
  readonly userCanCreateContent: boolean | null | undefined;
  readonly userForAnalytics: {
    readonly id: string | null | undefined;
  } | null | undefined;
};
export type SiteInformationQuery = {
  response: SiteInformationQuery$data;
  variables: SiteInformationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
},
v1 = {
  "kind": "ScalarField",
  "name": "timeZone"
},
v2 = [
  {
    "concreteType": "Tenant",
    "kind": "LinkedField",
    "name": "tenant",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "shard"
      },
      {
        "kind": "ScalarField",
        "name": "cloudId"
      },
      {
        "kind": "ScalarField",
        "name": "environment"
      },
      {
        "kind": "ScalarField",
        "name": "activationId"
      }
    ]
  },
  {
    "concreteType": "Organization",
    "kind": "LinkedField",
    "name": "organization",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "orgId"
      }
    ]
  },
  {
    "alias": "userForAnalytics",
    "concreteType": "AtlassianUser",
    "kind": "LinkedField",
    "name": "confluence_atlassianUser",
    "plural": false,
    "selections": [
      (v0/*: any*/)
    ]
  },
  {
    "alias": "user",
    "args": [
      {
        "kind": "Literal",
        "name": "current",
        "value": true
      }
    ],
    "concreteType": "AtlassianUser",
    "kind": "LinkedField",
    "name": "confluence_atlassianUser",
    "plural": false,
    "selections": [
      (v0/*: any*/),
      {
        "kind": "ScalarField",
        "name": "displayName"
      },
      {
        "concreteType": "ConfluenceUser",
        "kind": "LinkedField",
        "name": "confluence",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "accessStatus"
          },
          {
            "kind": "ScalarField",
            "name": "accountId"
          },
          {
            "kind": "ScalarField",
            "name": "userKey"
          },
          {
            "kind": "ScalarField",
            "name": "locale"
          }
        ]
      },
      (v1/*: any*/)
    ],
    "storageKey": "confluence_atlassianUser(current:true)"
  },
  {
    "args": [
      {
        "kind": "Literal",
        "name": "product",
        "value": "CONFLUENCE"
      }
    ],
    "concreteType": "AIConfigResponse",
    "kind": "LinkedField",
    "name": "getAIConfig",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "isEnabled"
      },
      {
        "kind": "ScalarField",
        "name": "isRovoEnabled"
      },
      {
        "kind": "ScalarField",
        "name": "isAIEarlyAccessEnabled"
      },
      {
        "kind": "ScalarField",
        "name": "isRovoLLMEnabled"
      }
    ],
    "storageKey": "getAIConfig(product:\"CONFLUENCE\")"
  },
  {
    "concreteType": "ConfluenceTenantContext",
    "kind": "LinkedField",
    "name": "confluence_tenantContext",
    "plural": false,
    "selections": [
      {
        "concreteType": "LicenseStates",
        "kind": "LinkedField",
        "name": "licenseStates",
        "plural": false,
        "selections": [
          {
            "concreteType": "LicenseState",
            "kind": "LinkedField",
            "name": "confluence",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "ccpEntitlementId"
              }
            ]
          }
        ]
      },
      (v1/*: any*/),
      {
        "concreteType": "Editions",
        "kind": "LinkedField",
        "name": "editions",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "confluence"
          }
        ]
      },
      {
        "kind": "ScalarField",
        "name": "monolithRegion"
      }
    ]
  },
  {
    "kind": "ScalarField",
    "name": "isSiteAdmin"
  },
  {
    "kind": "ScalarField",
    "name": "abTestCohorts"
  },
  {
    "kind": "ScalarField",
    "name": "experimentFeatures"
  },
  {
    "kind": "ScalarField",
    "name": "userCanCreateContent"
  },
  {
    "kind": "ScalarField",
    "name": "isNewUser"
  },
  {
    "concreteType": "SiteSettings",
    "kind": "LinkedField",
    "name": "siteSettings",
    "plural": false,
    "selections": [
      {
        "concreteType": "Homepage",
        "kind": "LinkedField",
        "name": "homepage",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "uri"
          },
          {
            "kind": "ScalarField",
            "name": "title"
          }
        ]
      },
      {
        "kind": "ScalarField",
        "name": "siteTitle"
      },
      {
        "kind": "ScalarField",
        "name": "showApplicationTitle"
      },
      {
        "concreteType": "FrontCover",
        "kind": "LinkedField",
        "name": "frontCover",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "frontCoverState"
          }
        ]
      },
      {
        "kind": "ScalarField",
        "name": "companyHubName"
      },
      {
        "kind": "ScalarField",
        "name": "isHideTitleInUrl"
      }
    ]
  },
  {
    "concreteType": "SiteDescription",
    "kind": "LinkedField",
    "name": "siteDescription",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "logoUrl"
      }
    ]
  },
  {
    "concreteType": "CurrentConfluenceUser",
    "kind": "LinkedField",
    "name": "currentConfluenceUser",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "isAnonymous"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "SiteInformationQuery",
    "selections": (v2/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "SiteInformationQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "276cc0ce194a50887281eed054abed3f",
    "id": "0db505607c0944e5068444603d621d9ae560a39fed3fce4efe1483aed6d35fe0",
    "metadata": {},
    "name": "SiteInformationQuery",
    "operationKind": "query",
    "text": "query SiteInformationQuery{tenant{shard,cloudId,environment,activationId},organization{orgId},userForAnalytics:confluence_atlassianUser{id},user:confluence_atlassianUser(current:true){id,displayName,confluence{accessStatus,accountId,userKey,locale},timeZone},getAIConfig(product:CONFLUENCE){isEnabled,isRovoEnabled,isAIEarlyAccessEnabled,isRovoLLMEnabled},confluence_tenantContext{licenseStates{confluence{ccpEntitlementId}},timeZone,editions{confluence},monolithRegion},isSiteAdmin,abTestCohorts,experimentFeatures,userCanCreateContent,isNewUser,siteSettings{homepage{uri,title},siteTitle,showApplicationTitle,frontCover{frontCoverState},companyHubName,isHideTitleInUrl},siteDescription{logoUrl},currentConfluenceUser{isAnonymous}}"
  }
};
})();

(node as any).hash = "371da0ad5ade920a87bf2743b04c7584";

export default node;
